import { cn } from '@dreamstack/util/src/cn'
import Image from 'next/image'
import type { ComponentProps } from 'react'

type ImageCoverProps = Omit<ComponentProps<typeof Image>, 'fill'> & {
  fill?: boolean
}

export const ImageCover = ({
  className,
  fill = true,
  alt = '',
  ...rest
}: ImageCoverProps) => (
  <Image
    {...rest}
    alt={alt}
    fill={fill}
    className={cn('object-cover bg-accentroGray-200', className)}
  />
)
